"use client";

import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

export default function ScoreIndicator({
  score,
  strokeWidth,
}: {
  score: number;
  strokeWidth?: number;
}) {
  return (
    <CircularProgressbarWithChildren
      styles={buildStyles({
        pathColor: `#00F3CD`,
        trailColor: "#2a423e",
        textColor: "#00F3CD",
      })}
      maxValue={5}
      value={score}
      strokeWidth={strokeWidth}
    >
      <p className="text-primary-color">{`${Number(score?.toFixed(1))}/5`}</p>
    </CircularProgressbarWithChildren>
  );
}
